import React, { useState } from 'react'
import Grid from '@material-ui/core/Grid'
import { Header, FieldName, FieldValue } from '../_local/styles'
import Pencil from '@material-ui/icons/Edit'
import YourPitchDialog from '../_local/modals/YourPitchDialog'
import Chip from '@material-ui/core/Chip'
import { getPitchFields } from '../service'
import { retrieveTagsFromEntities } from '../../../../shared/helpers/tags-set'
import { Box, Button } from '@material-ui/core'

const getTags = (tags) => {
  return (
    <FieldValue>
      {tags.map((tag, index) => (
        <Chip key={index} label={`${tag}`} size="small" style={{ margin: 5 }} />
      ))}
    </FieldValue>
  )
}

const YourPitchRow = (props) => {
  const {
    industryTags,
    financialTags,
    softwareTags,
    workExperiences,
    externalProjects,
    personalSummary,
    setPropChange,
  } = props

  const [open, setOpen] = useState(false)

  const initialValues = {
    industryTags: retrieveTagsFromEntities('industryTags', industryTags || [], workExperiences, externalProjects),
    financialTags: retrieveTagsFromEntities('financialTags', financialTags || [], workExperiences, externalProjects),
    softwareTags: retrieveTagsFromEntities('softwareTags', softwareTags || [], workExperiences, externalProjects),
    id: personalSummary.id || undefined,
    aboutYourself: personalSummary.aboutYourself || '',
    topIndustries: personalSummary.topIndustries || [],
    topFinancialSkills: personalSummary.topFinancialSkills || [],
    topSoftwareSkills: personalSummary.topSoftwareSkills || [],
    whyFreelanceWork: personalSummary.whyFreelanceWork || '',
  }

  const sortedFields = {
    aboutYourself: initialValues.aboutYourself,
    whyFreelanceWork: initialValues.whyFreelanceWork,
    topIndustries: initialValues.topIndustries,
    topFinancialSkills: initialValues.topFinancialSkills,
    topSoftwareSkills: initialValues.topSoftwareSkills,
  }

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      <Grid container justify="space-between" alignItems="center">
        <Grid item>
          <Header>Your Pitch</Header>
        </Grid>
        <Button onClick={handleClickOpen} startIcon={<Pencil />} color="primary">
          Edit
        </Button>
      </Grid>

      <Box style={{ width: '75%' }}>
        <Grid container spacing={5}>
          {Object.entries(sortedFields).map((field, index) => {
            const formattedFields = getPitchFields(field)
            const hasTags = Array.isArray(formattedFields?.value)
            return (
              <Grid item key={index}>
                <FieldName>{formattedFields?.label}</FieldName>
                {!hasTags ? <FieldValue>{formattedFields?.value}</FieldValue> : <>{getTags(formattedFields?.value)}</>}
              </Grid>
            )
          })}
        </Grid>
      </Box>
      <YourPitchDialog
        open={open}
        handleClose={handleClose}
        initialValues={initialValues}
        setPropChange={setPropChange}
      />
    </>
  )
}

export default YourPitchRow
